<template>
  <div class="modal fade cookies" id="cookies_poppup" tabindex="-1" role="dialog" aria-labelledby=""
       aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Wil je onze optimale<br> cookies accepteren?</h5>
          <h4>
            We willen jouw toestemming vragen om optimale cookies te gebruiken om Odido.nl voor jou relevanter te
            maken. Als je
            kiest voor optimale cookies ervaar je one website zo optimal mogelik, met bijvoorbeeld advertenties die
            helemaal op jou
            zijn afgestemd. Je geeft ons ook toestemming om jouw internetgedrag binnen, en mogelik ook buiten, one
            website te
            volgen. Met deze informatie passen wij en derde partijen de website, one communicatie en advertenties aan op
            jouw
            interesses en profiel.
          </h4>
          <h4 class="mt-1">
            Om de optimale cookies te plaatsen klik je hieronder op 'Ja, cookies accepteren'. Voor meer informatie of
            het aanpassen
            van je cookie instellingen, <a href="https://odido.nl/cookies">kun je hier terecht.</a> Op die pagina
            kun je jouw keuze altijd weer
            wijzigen.
          </h4>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer">
          <a href="static/docs/Privacy_Statement.pdf" class="pdf_link">
            <img src="static/img/millen_images/pdf_icon.svg">
            Cookiebeleid
          </a>
          <button id="Row1_Column1_Cell1_CookieSettings_AdvancedSaveAccept" @click.prevent="acceptCookies" type="button"
                  class="black_btn step1">Ja, cookies accepteren</button>
          <button id="Row1_Column1_Cell1_CookieSettings_AdvancedSaveDeny" @click.prevent="denyCookies" type="button"
                  class="black_secondary_btn">Nee, liever niet</button>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
    name: "Cookies",
    data() {
      return {
        showPopup: true,
        showGoogle: false,
        cookieValue: null
      }
    },
    mounted() {
      this.$nextTick(function () {
        // cookie name:tm_cookie_setting
        // values:
        //  if "compleet" accepted -> "Tracking"
        //  if "beperkt" accepted -> "Analytics"
        //  if empty toon cookie popup.

        this.cookieValue = this.accessCookie("pps_cookie_setting");
        const head = document.getElementsByTagName('head')[0];
        //const blueconicScript = document.createElement("script");
        //blueconicScript.type = "text/javascript";
        //blueconicScript.src = "//cdn.blueconic.net/tmobile.js";


        if (this.cookieValue === null || this.cookieValue === "") {
          $('#cookies_poppup').modal('show')
        } else if (this.cookieValue === "Tracking") {
          this.showGoogle = true;
          this.showPopup = false;
        } else if (this.cookieValue === "Analytics") {
          this.showGoogle = false;
          this.showPopup = false;
        }

        if (this.showPopup === false)
          $('#cookies_poppup').modal('hide')
        else
          $('#cookies_poppup').modal('show')


      })
    },


    methods: {

      accessCookie(cookieName) {
        var name = cookieName + "=";
        var allCookieArray = document.cookie.split(';');
        for (var i = 0; i < allCookieArray.length; i++) {
          var temp = allCookieArray[i].trim();
          if (temp.indexOf(name) == 0)
            return temp.substring(name.length, temp.length);
        }
        return "";
      },

      acceptCookies() {
        this.showPopup = false;
        $('#cookies_poppup').modal('hide')

        this.showGoogle = true;
        this.createCookie("pps_cookie_setting", "Tracking");
      },

      denyCookies() {
        this.showPopup = false;
        $('#cookies_poppup').modal('hide')

        this.showGoogle = false;
        this.createCookie("pps_cookie_setting", "Analytics");
      },

      createCookie(cookieName, cookieValue) {
        var expiration_date = new Date();
        expiration_date.setFullYear(expiration_date.getFullYear() + 1);
        document.cookie = cookieName + "=" + cookieValue + "; expires=" + expiration_date.toUTCString();
      }

    }


  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/Cookies.vue